import React, { useState, useEffect } from "react";
import {
  Box,
  Center,
  Flex,
  Spinner,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { QRCodeCanvas } from "qrcode.react";
import { LynxId } from "../profilePage/profileApi.js";
import { useSelector, useDispatch } from "react-redux";
import { updateToken } from "../../state/index.js";

const Lynxid = () => {
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const { colorMode } = useColorMode();

  const [lynxId, setLynxId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLynxId = async () => {
      if (!token) {
        setError("No token found. Please log in again.");
        return;
      }

      try {
        const data = await LynxId(token);
        setLynxId(data);
        dispatch(updateToken(token));
      } catch (err) {
        if (!navigator.onLine) {
          setError(`No Internet Connection`);
        }
        // console.error("Failed to fetch Lynx ID. Using dummy data.", err);
        setLynxId(dummyLynxId);
        // setError(err.message);
        setLoading(false);
      }
    };

    fetchLynxId();
  }, [token, dispatch]);
  const dummyLynxId = {
    id: "LynxID-12345678",
  };
  if (loading) {
    return (
      <Center height="100vh" width="100%">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Center>
    );
  }

  if (error) {
    return (
      <Text color="red.500" textAlign="center" mt={5}>
        Error: {error}
      </Text>
    );
  }

  return (
    <Center>
      {lynxId ? (
        <Flex justifyContent="center">
          <Box
            textAlign="center"
            size="2xl"
            w="100%"
            p={4}
            borderRadius={5}
            bg="white"
            border="1px solid black"
          >
            <QRCodeCanvas
              value={lynxId.id || ""}
              size={250}
              style={{ width: "100%", height: "auto" }}
            />
          </Box>
        </Flex>
      ) : (
        <Text textAlign="center" mt={5} fontSize="lg">
          Lynx ID not present.
        </Text>
      )}
    </Center>
  );
};

export default Lynxid;